import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=63fc33e2&"
import script from "./FormCheckbox.vue?vue&type=script&lang=ts&"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&id=63fc33e2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63fc33e2')) {
      api.createRecord('63fc33e2', component.options)
    } else {
      api.reload('63fc33e2', component.options)
    }
    module.hot.accept("./FormCheckbox.vue?vue&type=template&id=63fc33e2&", function () {
      api.rerender('63fc33e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/form/FormCheckbox.vue"
export default component.exports